jQuery(function ($) {
  /*
   *
   *	Place items in here to have them run after the Dom is ready
   *
   */

  const mobileMax = 999;
  const desktopMin = 1000;

  let viewWidth = window.innerWidth;
  let isMobile = viewWidth <= mobileMax;

  //returns true if you have just switched between mobile and desktop views
  function viewHasChangedMobile() {
    let wasMobile = isMobile;
    viewWidth = window.innerWidth;
    isMobile = viewWidth <= mobileMax;
    return isMobile !== wasMobile;
  }

  // GA Event for Button CTA
  $(".inner-content-footer a").on("click", function () {
    let link_text = $(this).text();
    // gtag("event", "click", {
    //   event_category: "Link",
    //   event_label: `Button - ${link_text}`,
    // });
  }); 

  // detect if selector is being hovered
  function isHovered(selector) {
    return $(selector + ":hover").length > 0;
  }

  setTimeout(function () {
    $("a.environment-hotspot").addClass("loaded");
  }, 1750);

  /* ********************************************** */
  /* Start: Customizations for 3D Video Experience */
  /* ********************************************** */

  // Elements
  let main_3d_video_player = videojs("main-3d-video"),
    rotate_buttons = $(".btn.rotate"),
    hotspot_groups = $(".hotspot-group");

  // Video Variables
  let firstAnglePause = 6, // seconds into the video
    secondAnglePause = 11.25, //11.5
    thirdAnglePause = 16.7,
    secondAngleReversePause = 21.7, //22
    hotspot_ids = ["#hotspots-1", "#hotspots-2", "#hotspots-3", "#hotspots-2"],
    pausePoints = [
      firstAnglePause,
      secondAnglePause,
      thirdAnglePause,
      secondAngleReversePause,
    ],
    totalAngles = 4,
    angleToShow = 1;

  function prepBooth() {
    var isPlaying =
      main_3d_video_player.currentTime > 0 &&
      !main_3d_video_player.paused &&
      !main_3d_video_player.ended &&
      main_3d_video_player.readyState > 2;

    if (!isPlaying) {
      main_3d_video_player.play();
      var pauseAtFirstAngle = function () {
        if (this.currentTime() >= firstAnglePause) {
          this.pause();
          showHotspots();
          rotate_buttons.removeClass("hidden");
          this.off("timeupdate", pauseAtFirstAngle);
        }
      };
      main_3d_video_player.on("timeupdate", pauseAtFirstAngle);
    }
  }

  function resetVideo() {
    main_3d_video_player.currentTime(firstAnglePause);
  }

  function hideHotspots() {
    $("a.environment-hotspot").removeClass("pulse");
    hotspot_groups.removeClass("shown");
    rotate_buttons.attr("disabled", true);
  }

  function showHotspots() {
    $(hotspot_ids[angleToShow - 1]).addClass("shown");
    $("a.environment-hotspot").addClass("pulse");
    rotate_buttons.attr("disabled", false);
  }

  function rotateRoom() {
    hideHotspots();

    let resettingVid = false;

    if (angleToShow < totalAngles) {
      angleToShow += 1;
    } else {
      resettingVid = true;
      angleToShow = 1;
    }

    let pauseTime = pausePoints[angleToShow - 1];

    main_3d_video_player.play();

    var pauseVid = function () {
      if (pauseTime && this.currentTime() >= pauseTime) {
        this.pause();
        showHotspots();
        this.off("timeupdate", pauseVid);
        if (angleToShow > 2) {
          $(".btn.rotate").addClass("reverse");
        }
      }
    };

    if (!resettingVid) {
      main_3d_video_player.on("timeupdate", pauseVid);
    }

    main_3d_video_player.on("ended", function () {
      showHotspots();
      resetVideo();
      $(".btn.rotate").removeClass("reverse");
    });
  }

  main_3d_video_player.ready(function () {
    // if desktop, show angle hotspot group
    if (!isMobile) {
      prepBooth();
      // showHotspots();
    }
  });

  // Add click listener to rotate button
  $(".btn.rotate").click(function () {
    rotateRoom();
  });

  /* ********************************************** */
  /* Mobile Slider */
  /* ********************************************** */

  if (isMobile) {
    $(".hotspots-wrapper").slick({
      dots: true,
      arrows: false,
      infinite: false,
      slide: ".hotspots-view",
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  /* ********************************************** */
  /* End: Main 3D Video Customizations */
  /* ********************************************** */

  function addHoverStateToHotspots() {
    // When a hotspot is hovered, add class hovering to assist with animation styling
    $("a.environment-hotspot").hover(
      function () {
        $(this).addClass("hovering");
        $(this).removeClass("pulse");
      },
      function () {
        $(this).addClass("pulse");
        $(this).removeClass("hovering");
      }
    );
  }

  // removes hover state from hotspot groups - used if view changes from desktop to mobile
  function removeHoverStateFromHotspots() {
    $("a.environment-hotspot").off("mouseenter mouseleave");
  }

  // if a hotspot group path is hovered on desktop
  if (!isMobile) {
    addHoverStateToHotspots();
  }

  $(document).ready(function () {});

  /*
   *
   *	Place items in here to have them run the page is loaded
   *
   */

  $(window).load(function () {});

  /*
   *
   *	Place items in here to have them run when the window is scrolled
   *
   */

  $(window).scroll(function () {});

  /*
   *
   *	Place items in here to have them run when the window is resized
   *
   */

  $(window).resize(function () {});

  /*
   *
   *	Place items in here to have them run when the window is done resizing
   *
   */

  let resize_timer;
  $(window).on("resize", function (e) {
    clearTimeout(resize_timer);
    resize_timer = setTimeout(function () {
      // if changing from one environment to the other
      if (viewHasChangedMobile()) {
        if (isMobile) {
          hideHotspots(); // clears random pulse timer
          removeHoverStateFromHotspots();
          $(".hotspots-wrapper").slick({
            dots: true,
            arrows: false,
            infinite: false,
            slide: ".hotspots-view",
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
          });
        } else {
          $(".hotspots-wrapper").slick("unslick");
          // showHotspots();
          prepBooth();
          addHoverStateToHotspots();
        }
      }
    }, 250);
  });
});
